import React, { useState } from "react";
import {DefaultButton, Dialog, DialogFooter, PrimaryButton} from '@fluentui/react';

const RestorePowerAppSolutionBtn = ({solution, updateSolution}) => {

    const [showDialog, setShowDialog] = useState(false)

    const _onConfirmDialog = () => {
        updateSolution(null, null, null, null, true);
        setShowDialog(false)
    }

    const _onCancelDialog = () => {
        setShowDialog(false)
    }

    const confirmationDialog = 
        <Dialog 
            hidden={!showDialog}
            maxWidth={600}
            dialogContentProps={{
                title: `Confirm Restore of "${solution.name}" ${solution.type}`,
            }}
            modalProps={{
                isBlocking: false
            }}
        >
            <div>
               <p>Are you sure you want to restore this deleted <strong>{solution.name}</strong> {solution.type}?</p>
            </div>
            <DialogFooter>
                <PrimaryButton onClick={_onConfirmDialog} text="Confirm" />
                <DefaultButton onClick={_onCancelDialog} text="Cancel" />
            </DialogFooter>
        </Dialog>

    return (
        <div style={{float: 'right', marginRight: '-12px'}}>
            <DefaultButton
                text='Restore'
                className="edit-icon"
                onClick={() => setShowDialog(true)}
            />
            {confirmationDialog}
        </div>
    )
}

export default RestorePowerAppSolutionBtn;



// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEditElements/RestorePowerAppSolutionBtn.js